import { WellbeingSVG } from "./SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { WELLBEING_ITEMS, WELLBEING_OPTIONS, classifyWellbeing } from "./helpers";

export default function Step3Wellbeing({ answers, onChange, allAnswered, score, errors }) {
  const cls = allAnswered ? classifyWellbeing(score) : null;

  return (
    <div>
      <WellbeingSVG />

      <div
        className="rounded-[14px] p-3 mt-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#F3E5F0", border: "1px solid rgba(136,52,118,0.15)", color: "#2D2A24" }}
      >
        Indica con qué frecuencia estas afirmaciones <strong>aplican a ti</strong>.
      </div>

      {WELLBEING_ITEMS.map((item, i) => (
        <div key={item.id} className="mb-4">
          <span className="text-xs font-semibold block mb-1" style={{ color: "#2D2A24" }}>
            {item.label}
          </span>
          <PillSelect
            options={WELLBEING_OPTIONS}
            value={answers[i] ?? ""}
            onChange={(v) => onChange(i, v)}
            error={errors?.getError(`wb_${i}`)}
            testId={`f5-wb-${item.id}`}
            columns={1}
          />
        </div>
      ))}

      {allAnswered && cls && (
        <CalculatedBadge
          label="Bienestar interno"
          value={`${score}/20`}
          category={cls.label}
          categoryColor={cls.color}
          testId="badge-bienestar"
        />
      )}
    </div>
  );
}
